"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findReportDefinition = findReportDefinition;
exports.findReportDataForUid = findReportDataForUid;

var _lodash = require("lodash");

function findReportDefinition(uid, reportsReducerState) {
    return (0, _lodash.find)(reportsReducerState.reportDefinitions, function (definition, index) {
        return uid === definition.uid;
    });
}
function findReportDataForUid(uid, report, reportDefinition, reportData) {
    return (0, _lodash.chain)(reportData).thru(function (result) {
        reportData = result;
        return result;
    }).filter(function (item) {
        return item.dataDefinition.uid === uid;
    }).last().value();
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reports/reportUtils.ts
 ** module id = 644
 ** module chunks = 0
 **/